import { Box, Button, Flex } from '@chakra-ui/react';
import NextImage from 'next/image';
import { useTranslation } from 'react-i18next';

import { EventSponsor } from '@/resources/EventSponsor';

export function SponsorCardContent({ eventSponsor }: { eventSponsor: EventSponsor }) {
  const { t } = useTranslation();
  const { largeLogoImageUrl, name, enabledFeatures, streamActive } = eventSponsor;

  const hasAction = enabledFeatures.directLink || enabledFeatures.about || enabledFeatures.qa;

  const qaActive = enabledFeatures.qa && streamActive;

  const sponsorButtonTranslationKey = () => {
    if (qaActive) {
      return 'join';
    }

    if (enabledFeatures.about) {
      return 'learnMore';
    }

    return 'website';
  };

  return (
    <Flex
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      p={4}
      bgColor="white"
      _hover={{
        boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.08)',
      }}
    >
      <NextImage src={largeLogoImageUrl} alt={name} width={148} height={148} style={{ marginBottom: 16 }} />

      {hasAction && (
        <Button as="span" mb={1} variant="outline" size="sm" w="full">
          {t(`expo.card.${sponsorButtonTranslationKey()}`)}
        </Button>
      )}
    </Flex>
  );
}
